import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-satured-chip',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './satured-chip.component.html',
  styleUrls: ['./satured-chip.component.scss'],
})
export class SaturedChipComponent {


}
